<template>
	<event-color-input v-if="visible" v-model="value" :class="[clazz, errorClass]" :style="style" :readonly="ro" :tabindex="ti" :required="!!ec.required"></event-color-input>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {computed} from "vue";
import EventColorInput from "@fd/editors/color/EventColorInput.vue";
import type {EventColor} from "@t/fd/editor/EventColor.ts";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const ec = computed<EventColor>(() => props.part as EventColor);
const {visible, value, clazz, style, ro, errorClass} = useEditor(props);

const ti = computed<number>(() => {
	return typeof ec.value.tabindex === "number" ? ec.value.tabindex : 0;
});
</script>

<style>

</style>